import styled from 'styled-components';

export const Container = styled.img`
  height: 72px;
  padding: 8px 0;

  @media screen and (max-width: 766px) {
    padding: 5px 0;
  }
`
